export default __webpack_public_path__ + "static/animation-77c92231d4765eb3a1f1da1838afe753.mp4";